import { Button } from '@finn/design-system/atoms/button';
import { cn, useIntl } from '@finn/ui-utils';

import { GenericVehicleDetails } from '../../core/types';
import { getConfigLineLabel, useProductLabel } from '../../product-cards';
import { PartialCartInfo, useSubscriptionPrice } from '../../product-pricing';

type Props = {
  vehicle: GenericVehicleDetails;
  incentiveLabel?: string;
  className?: string;
  handleMoreInformationClick: () => void;
  closedUserGroupId: string;
  cartInfo: PartialCartInfo;
  triggerDevModal?: () => void;
};

export const VehicleMainDetails = ({
  vehicle,
  className,
  handleMoreInformationClick,
  closedUserGroupId,
  cartInfo,
  triggerDevModal,
}: Props) => {
  const intl = useIntl();

  const { partnerDiscount } = useSubscriptionPrice({
    trackPartnerDiscount: true,
    closedUserGroupId,
    cartInfo,
  });

  const productLabel = useProductLabel(vehicle, partnerDiscount);

  const configLine = getConfigLineLabel(vehicle);

  return (
    <div className={cn('flex flex-col gap-3', className)}>
      {((!partnerDiscount && productLabel) || !vehicle.availability) && (
        <span
          className={cn(
            'body-14-semibold',
            vehicle.availability ? 'text-trustedBlue' : 'text-iron'
          )}
        >
          {productLabel}
        </span>
      )}
      <div onClick={triggerDevModal}>
        <h1 className="mobile-t4-semibold">
          {vehicle.brand.id} {vehicle.model}
        </h1>
      </div>

      {configLine && <h2 className="body-16-light">{configLine}</h2>}

      <Button variant="action" onClick={handleMoreInformationClick}>
        {intl.formatMessage('pdp.carInfo')}
      </Button>
    </div>
  );
};
